/**
 * Persistence configuration for the Subscription store module
 *
 * @author Matt Kenefick <matt@polymermallard.com>
 * @package Store/Module/Subscription
 * @project ChalkySticks
 */
const persist = {
	/**
	 * Persist subscription state to localStorage
	 *
	 * @type boolean
	 */
	enabled: true,

	/**
	 * Storage key for persistence
	 *
	 * @type string
	 */
	key: 'chalkysticks-subscription',

	/**
	 * Paths to persist - we only persist minimal data for security
	 * Customer info and offerings should always be fetched fresh
	 *
	 * @type string[]
	 */
	paths: ['hasPremium', 'lastStatusCheck'],

	/**
	 * Storage type
	 *
	 * @type Storage
	 */
	storage: window.localStorage,
};

export default persist;
